import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import IconButton from "@mui/material/IconButton";

const FooterIcon = ({type}) => {
	let chosenIcon = null;
	switch(type) {
		case "facebook":
			chosenIcon = <IconButton sx={{color: 'blue'}}>
                    <FacebookRoundedIcon sx={{
                        fontSize: 30,
                    }}/>
                </IconButton>;
            break;
        case "twitter":
        	chosenIcon = <IconButton sx={{color: '#7cb9ea'}}>
                    <TwitterIcon sx={{
                        fontSize: 30,
                    }}/>
                </IconButton>;
            break;
        case "linkedin":
        	chosenIcon = <IconButton sx={{color: '#6093BB'}}>
                    <LinkedInIcon sx={{
                        fontSize: 30,
                    }}/>
                </IconButton>;
            break;
        case "instagram":
        	chosenIcon = <IconButton sx={{color: 'red'}}>
                    <InstagramIcon sx={{
                        fontSize: 30,
                    }}/>
                </IconButton>;
            break;
        default:
        	chosenIcon = <></>
        	break;
	}
	return chosenIcon;
}

export default FooterIcon;